
import React from 'react';
import { Button } from '@/components/ui/button';
import { Edit } from 'lucide-react';
import SleepAssessmentEdit from '../SleepAssessmentEdit';

interface SleepSectionProps {
  data: {
    difficultyWakingUp: string;
    notWellRested: string;
    exhaustedWhenWaking: string;
    difficultyFallingAsleep: string;
    wakeUpTooEarly: string;
    wakeUpSeveralTimes: string;
    poorSleep: string;
  };
  editMode: string | null;
  onEditToggle: (section: string) => void;
  onSave: (section: string, data: any) => void;
}

const SleepSection: React.FC<SleepSectionProps> = ({ 
  data, 
  editMode, 
  onEditToggle, 
  onSave 
}) => {
  return (
    <>
      {editMode === 'sleepAssessment' ? (
        <SleepAssessmentEdit 
          data={data} 
          onSave={(data) => onSave('sleepAssessment', data)}
          onCancel={() => onEditToggle('sleepAssessment')}
        />
      ) : (
        <div className="space-y-4">
          <div className="space-y-3">
            <div className="flex justify-between p-3 bg-muted/50 rounded-md">
              <span className="text-muted-foreground">Difficulty waking up</span>
              <span className="font-medium">{data.difficultyWakingUp}</span>
            </div>
            <div className="flex justify-between p-3 bg-muted/50 rounded-md">
              <span className="text-muted-foreground">Not well rested</span>
              <span className="font-medium">{data.notWellRested}</span>
            </div>
            <div className="flex justify-between p-3 bg-muted/50 rounded-md">
              <span className="text-muted-foreground">Exhausted when waking</span>
              <span className="font-medium">{data.exhaustedWhenWaking}</span>
            </div>
            <div className="flex justify-between p-3 bg-muted/50 rounded-md">
              <span className="text-muted-foreground">Difficulty falling asleep</span>
              <span className="font-medium">{data.difficultyFallingAsleep}</span>
            </div>
            <div className="flex justify-between p-3 bg-muted/50 rounded-md">
              <span className="text-muted-foreground">Wake up too early</span>
              <span className="font-medium">{data.wakeUpTooEarly}</span>
            </div>
            <div className="flex justify-between p-3 bg-muted/50 rounded-md">
              <span className="text-muted-foreground">Wake up several times</span>
              <span className="font-medium">{data.wakeUpSeveralTimes}</span>
            </div>
            <div className="flex justify-between p-3 bg-muted/50 rounded-md">
              <span className="text-muted-foreground">Poor sleep quality</span>
              <span className="font-medium">{data.poorSleep}</span>
            </div>
          </div>
          <Button
            variant="outline"
            size="sm"
            className="mt-2"
            onClick={() => onEditToggle('sleepAssessment')}
          >
            <Edit className="h-4 w-4 mr-2" />
            Edit Sleep Information
          </Button>
        </div>
      )}
    </>
  );
};

export default SleepSection;
